(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-score/assets/javascripts/betslips/standard.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-score/assets/javascripts/betslips/standard.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  Betslip = _svs$components$tipse.Betslip,
  useBetslipContext = _svs$components$tipse.useBetslipContext;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const format = svs.utils.format;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectSystemTypeForEvent = _svs$components$tipse2.selectSystemTypeForEvent,
  selectSROWForEvent = _svs$components$tipse2.selectSROWForEvent;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const productIds = svs.utils.products.productIds;
const _svs$components$tipse3 = svs.components.tipsen.engine.constants.couponStatus,
  COUPON_INVALID_OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS = _svs$components$tipse3.COUPON_INVALID_OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS,
  COUPON_INVALID_BOARD_HAS_TO_MANY_SELECTIONS = _svs$components$tipse3.COUPON_INVALID_BOARD_HAS_TO_MANY_SELECTIONS;
const errorMessages = {
  OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS: 'Max 10 markeringar per lag tillåtna.',
  BOARD_HAS_TO_MANY_SELECTIONS: 'Max 20 markeringar totalt tillåtna.',
  DEFAULT: 'Felaktigt ifylld kupong.'
};
const getNotValidCouponMessage = couponStatus => {
  let message = '';
  switch (couponStatus) {
    case COUPON_INVALID_OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS:
      message = errorMessages.OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS;
      break;
    case COUPON_INVALID_BOARD_HAS_TO_MANY_SELECTIONS:
      message = errorMessages.BOARD_HAS_TO_MANY_SELECTIONS;
      break;
    default:
      message = errorMessages.DEFAULT;
      break;
  }
  return message;
};
const RowCount = _ref => {
  let couponId = _ref.couponId,
    eventNumber = _ref.eventNumber,
    isMatchen = _ref.isMatchen;
  const eventSystemType = useSelector(state => selectSystemTypeForEvent(state, couponId, eventNumber));
  const rowCount = useSelector(state => selectSROWForEvent(state, couponId, eventNumber)).length;
  let systemTypeRows = eventSystemType;
  let rowsText = '';
  if (isMatchen) {
    systemTypeRows = rowCount;
    rowsText = systemTypeRows === 1 ? ' rad' : ' rader';
  }
  return React.createElement("span", null, systemTypeRows, rowsText);
};
const Standard = () => {
  const context = useBetslipContext();
  const isCouponValidWithDelay = context.isCouponValidWithDelay,
    isMedium = context.isMedium,
    price = context.price,
    couponId = context.couponId,
    couponStatus = context.couponStatus,
    isCouponValid = context.isCouponValid;
  const draw = useCurrentDraw();
  const shouldDisplayBalance = isCouponValidWithDelay && !isSelfService && isMedium;
  const shouldDisplayErrorMessage = (!isCouponValidWithDelay || !isCouponValid) && (couponStatus === COUPON_INVALID_OUTCOME_GROUP_HAS_TO_MANY_SELECTIONS || couponStatus === COUPON_INVALID_BOARD_HAS_TO_MANY_SELECTIONS);
  const blockName = 'pg_tipsen_betslip__content';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--valid_coupon")]: isCouponValidWithDelay,
    ["".concat(blockName, "--instructions")]: shouldDisplayErrorMessage
  });
  const productId = draw.productId;
  let isMatchen = false;
  if (productId === productIds.MATCHEN) {
    isMatchen = true;
  }
  return React.createElement("div", {
    className: classNames
  }, React.createElement("span", {
    className: "pg_tipsen_betslip_system_info pg_tipsen_betslip_system_info--score"
  }, React.createElement("div", {
    className: "pg_tipsen_betslip_system",
    style: {
      display: 'block'
    }
  }, draw.drawEvents.map((event, index, arr) => React.createElement(React.Fragment, {
    key: event.eventNumber
  }, React.createElement(RowCount, {
    couponId: couponId,
    eventNumber: event.eventNumber,
    isMatchen: isMatchen,
    key: event.eventNumber
  }), index !== arr.length - 1 && ' x ')))), shouldDisplayBalance && React.createElement("span", {
    className: "pg_tipsen_betslip_balance"
  }, React.createElement(Betslip.BalanceView, null)), shouldDisplayErrorMessage && React.createElement("span", {
    className: "pg_tipsen_betslip_system_instructions"
  }, getNotValidCouponMessage(couponStatus)), React.createElement("div", {
    className: "pg_tipsen_betslip_price"
  }, format.Currency(price), "\xA0KR"), isMatchen && isCouponValidWithDelay && React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button pg_tipsen_betslip_pay_button--with-progressbar"
  }, React.createElement(Betslip.PayButton, null)), !isMatchen && React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button pg_tipsen_betslip_pay_button--with-progressbar"
  }, React.createElement(Betslip.ProgressBar, null), isCouponValidWithDelay && React.createElement(Betslip.PayButton, null)));
};
setGlobal('svs.components.tipsen.betslipSelectorScore.betslips.Standard', Standard);

 })(window);